/**
 * FROZEN — do not add new flags to this list. CI will block your PR.
 *
 * Flags NOT in this list default to true in CI/test, which is correct:
 * tests should exercise the new code path. If your flag causes test failures:
 *
 *   1. Update failing tests to cover both code paths (flag on and off).
 *   2. Or mock ONLY your specific flag to false in the failing test.
 *
 * NEVER mock getFeatureFlag to return false for ALL flags.
 *
 * See: .cursor/rules/flow/feature-config/feature-flags.md
 */
export const DEFAULT_FALSE_FLAGS = [
  'code-gen',
  'devpl-2112-de-app-modes',
  'dyn-5021-prevent-site-indexing',
  'exp-growth-grow-5360-sites-sort-preference',
  'ff-ac-1-custom-site-roles',
  'ff-aeo-24-centralized-control-center',
  'ff-aether-poc',
  'ff-ai-site-builder-workers-circuit-breaker',
  'ff-aio-15-agent-service',
  'ff-aio-disable-google-error-normalization',
  'ff-apai-1193-deny-anthropic-requests',
  'ff-apai-1270-disable-logic-flows',
  'ff-apai-169-copilot',
  'ff-apai-1716-orion-usage-tracking',
  'ff-apai-1730-credits',
  'ff-apai-1784-rich-logging-orion',
  'ff-apai-2044-multi-turn-agent-migration',
  'ff-apai-2247-deny-openrouter-requests',
  'ff-apai-2331-edit-file-tool',
  'ff-apai-2412-compact-variables-list',
  'ff-apai-2787-vcc-screenshot',
  'ff-apai-258-deny-openai-requests',
  'ff-apai-995-compatible-with-design-assistant',
  'ff-ast-89-lazy-load-assets',
  'ff-ast-94-restrict-free-document-upload',
  'ff-bill-2255-billing-sync-with-stigg',
  'ff-bloop-1114-nest-prev-next-data',
  'ff-cam-26-campaigns',
  'ff-cam-variable-mode-props-creation',
  'ff-cld-631-auto-manifest-updates',
  'ff-cmsauth-2348-rich-text-copy-paste-analytics',
  'ff-cmsauth-2735-cms-item-cache-invalidation',
  'ff-cmsauth-3236-ai-field-content-generation-quick-mods',
  'ff-cmsext-1056-pick-pg-storage-layer',
  'ff-cmsext-1420-mutation-rate-limits',
  'ff-cmsext-1482-nova-ux',
  'ff-cmsext-1610-batch-long-running',
  'ff-cmsext-1673-pick-pg-enterprise-storage-layer',
  'ff-cmsext-360-cache-control',
  'ff-cmsext-555-collection-item-limits',
  'ff-cmsext-956-cms-selective-publishing',
  'ff-cmsext-1708-pg-self-healing',
  'ff-cmsext-1982-nova-repair-wait-for-reader-sync',
  'ff-cmsext-restore-use-upsert',
  'ff-collab-5218-comment-webhooks',
  'ff-collab-5813-version-enforcement',
  'ff-collab-node-sync-lock',
  'ff-core-1983-cloudflare-migration',
  'ff-core-2419-block-publishing-proxy-ssl-dns',
  'ff-core-2745-early-hints',
  'ff-cosmic-159-devlink',
  'ff-cosmic-437-cloudflare-sdk-deployer',
  'ff-crashm-1419-designer-diagnostics-reporting',
  'ff-csy-386-admin-library-install',
  'ff-dash-4227-use-chunked-streams',
  'ff-dash-4260-site-restore-logging',
  'ff-dash-4645-audit-log',
  'ff-dataloss-enhancements',
  'ff-dataloss-send-dom-version',
  'ff-desru-79-export-queue',
  'ff-desux-7544-chrome-drag-and-drop-canvas-logic',
  'ff-desux-7544-safari-drag-and-drop-canvas-logic',
  'ff-desux-7988-custom-code-ux',
  'ff-desux-8790-multi-select',
  'ff-desux-9969-navigator-refactor',
  'ff-desux-open-site-button',
  'ff-devpl-2200-enable-app-analytics-notifications',
  'ff-devpl-2348-site-level-app-install-bypass',
  'ff-devpl-2408-turnstile-killswitch',
  'ff-devpl-2485-show-legacy-token-generation',
  'ff-devpl-2536-deprecate-v1-apis',
  'ff-devpl-2713-apps-panel-quick-install',
  'ff-devpl-2764-enterprise-rate-limit-override',
  'ff-devpl-2900-app-deletion',
  'ff-devpl-2926-invite-app-installations',
  'ff-devpl-2997-app-settings-lockdown',
  'ff-devpl-3029-app-developer-plan-banner',
  'ff-devpl-3260-suggested-apps-for-forms',
  'ff-devpl-3371-google-tag-gateway',
  'ff-devpl-3437-multiple-google-tag-ids',
  'ff-devpl-3490-marketplace-app-badges',
  'ff-devpl-3490-marketplace-app-badges-api',
  'ff-devpl-3527-designer-extension-publishing',
  'ff-devpl-3550-gtg-xor-base64-encoder',
  'ff-devpl-3599-site-level-form-defaults',
  'ff-devpl-3629-marketplace-search-index-metrics',
  'ff-devpl-3664-ai-workflows-ui',
  'ff-devpl-3664-ai-workflows-backend',
  'ff-devpl-3803-exclude-password-page-forms',
  'ff-devpl-3896-app-modes-build-mode',
  'ff-devpl-4117-de-theme-api',
  'ff-devpl-4456-hide-orphan-form-rows',
  'ff-dperf-143-components-migration-killswitch',
  'ff-dperf-167-precise-symbols-in-secondary-locales',
  'ff-dperf-177-migration-lock-for-branched-sites',
  'ff-dperf-236-enable-precise-components',
  'ff-dperf-289-add-cache-control-to-dom-endpoints',
  'ff-dperf-798-flux-detailed-metrics',
  'ff-dperf-350-sharded-styles-new-sites',
  'ff-dperf-36-component-migration-lock',
  'ff-dperf-555-sharded-migration-killswitch',
  'ff-dperf-614-sharded-interactions-new-sites',
  'ff-ds-1682-design-system-inspector',
  'ff-ds-2710-dsi-dashboard',
  'ff-ds-895-designer-light-mode',
  'ff-ds-3684-designer-light-mode-default-theme',
  'ff-element-styles',
  'ff-enable-server-side-preload',
  'ff-ent-2504-hsts-for-everyone',
  'ff-epd-1344-workspace-immediate-cancellation',
  'ff-epd-915-site-plan-cancellation',
  'ff-ete-567-merchant-tax-id-local-lookup',
  'ff-exp-212-comment-email-send-immediately',
  'ff-exp-307-use-billing-item-endpoint',
  'ff-exp-310-support-starter-workspaces-canvas-purchase',
  'ff-exp-327-sta-from-dashboard',
  'ff-exp-38-strict-invite-rate-limits',
  'ff-flag-test',
  'ff-grow-3209-growth-ai-help-jun-v1',
  'ff-grow-4084-align-tag',
  'ff-grow-4252-aisg-webflow-library-scripts',
  'ff-grow-4397-aisb-killswitch',
  'ff-grow-4582-aisb-generation-without-libraries',
  'ff-grow-4613-aisb-multi-page-site-structure',
  'ff-grow-4750-ai-assistant',
  'ff-grow-4795-section-fragments',
  'ff-grow-5249-docked-modal',
  'ff-grow-5027-ai-entrypoint-aisb',
  'ff-grow-5044-aia-model-picker',
  'ff-grow-5156-disabling-llm-client-moderation',
  'ff-grow-5157-aia-activity-logs-button',
  'ff-grow-5204-openai-priority-processing',
  'ff-grow-5262-style-extraction',
  'ff-grow-5512-user-account-deletion',
  'ff-grow-entitlement-usage-notifications',
  'ff-growth-4987-force-fedcm',
  'ff-idsc-1055-ai-toggle-update-release',
  'ff-idsc-607-use-canonical-grace-middleware',
  'ff-idsc-624-scim-provisioning-kill-switch',
  'ff-idsc-728-performance-improvements',
  'ff-idsc-789-cms-fga-discoverability',
  'ff-idsc-852-workspace-audit-log-granular-access',
  'ff-idsc-ai-toggle-exclusion-list',
  'ff-imize-integration',
  'ff-ix3-conditions',
  'ff-keep-branches-on-admin-restores',
  'ff-keep-libraries-on-admin-restores',
  'ff-library-orphaned-content-recovery',
  'ff-lif-25-multi-sku-checkout-sites',
  'ff-loc-881-hide-component-localization-overlay',
  'ff-local-1028-corruption-recovery',
  'ff-local-1030-enable-recovery-on-new-sites',
  'ff-local-1109-corruption-recovery',
  'ff-local-1111-audit-panel-ui',
  'ff-local-804-upsell-dialog',
  'ff-local-815-log-localization-changes',
  'ff-new-style-selector-ui',
  'ff-on-canvas-sizing-controls',
  'ff-oo-905-optimize-limit-audience',
  'ff-op-1246-personalize-optimize-manage-audiences',
  'ff-op-1532-redirect-tests',
  'ff-op-1534-graduation-flows-apply-changes',
  'ff-op-1535-ai-optimize-playbooks',
  'ff-op-1638-optimize-integrations-ga4-segment-mixpanel',
  'ff-op-1735-show-custom-audience-attributes',
  'ff-op-1740-locale-audience',
  'ff-op-1813-optimize-demo-mode',
  'ff-op-1979-ai-assistant-variations-components',
  'ff-op-2016-fetch-standalone-sites',
  'ff-op-2016-return-standalone-fixture',
  'ff-op-2087-logic-deprecation',
  'ff-op-2270-ab-relaunching',
  'ff-op-2584-ai-traffic-source',
  'ff-op-2647-analyze-optimize-goal-interop',
  'ff-op-2793-page-view-create-modal',
  'ff-op-2857-playbook-prompt',
  'ff-op-2884-new-report-ai-optimize',
  'ff-op-2884-new-report-personalize',
  'ff-op-2884-new-report-test',
  'ff-op-724-delete-optimization-wrappers',
  'ff-op-946-optimization-click-goals',
  'ff-optimization-upsell',
  'ff-pdty-6845-disable-hash',
  'ff-per-page-css',
  'ff-per-page-javascript',
  'ff-plex-200-dashboard-share-invite',
  'ff-pro-1-edu',
  'ff-proj-aeo-18-sitemap-index-api',
  'ff-pymt-pnp-4-2-site-plans',
  'ff-pymt-2564-sunset-billing-sync',
  'ff-pymt-2567-ss-block',
  'ff-pymt-2720-sunset-billing-sync-item-creation',
  'ff-pymt-3101-billing-sub-dal-uses-stigg',
  'ff-pymt-3716-enable-marketplace-anrok',
  'ff-pymt-4182-ent-sitenames',
  'ff-pymt-4362-ao-overages',
  'ff-pymt-4559-additional-stripe-metadata',
  'ff-pymt-4576-asset-link',
  'ff-pymt-4791-block-empty-user-agent-traffic',
  'ff-pymt-4797-enable-post-reconciliation-delay',
  'ff-pymt-4797-enable-reconciliation-for-prev-billing-month',
  'ff-pymt-4877-cube-check',
  'ff-pymt-4880-add-getworkspacesiteshandler',
  'ff-pymt-4919-dashboard-teams-paginate-sites',
  'ff-pymt-4934-before-you-go',
  'ff-pymt-4944-site-client-management',
  'ff-pymt-4954-fix-pagination-search-flicker',
  'ff-pymt-4961-dashboard-folder-retain',
  'ff-pymt-5119-checkout-in-designer',
  'ff-pymt-5235-allow-self-provisioning-ent-site-plan',
  'ff-rel-2956-cloudflare-custom-domains',
  'ff-sample-code-library',
  'ff-scale-496-localized-libraries',
  'ff-sd-212-hreflang-updates',
  'ff-sd-95-llms-txt',
  'ff-sd-ai-powered-seo',
  'ff-sd-default-global-canonical',
  'ff-shsvs-6249-feature-config-dashboard',
  'ff-shsvs-7416-da-test',
  'ff-shsvs-7599-load-server-config',
  'ff-shsvs-7840-should-load-webflow-next-context',
  'ff-shsvs-7908-connect-to-sprig',
  'ff-shsvs-7934-test-visibility-flag',
  'ff-shsvs-7957-bottom-right-knock-guide-notification',
  'ff-shsvs-8008-admin-workspace-page-site-pagination',
  'ff-shsvs-8011-ipn-slot-mechanism',
  'ff-shsvs-8054-should-load-enterprise-context',
  'ff-shsvs-session-replay-eligible-flags',
  'ff-shsvs-session-replay-recording-enabled',
  'ff-sps-3505-agency-guest',
  'ff-sps-3700-aag-legacy-conversion',
  'ff-sps-3821-partner-sandbox-provisioning',
  'ff-sps-4065-site-profile-mrp-dual-mutation',
  'ff-sps-4065-site-profile-mrp-dual-read-compare-only',
  'ff-sps-4065-site-profile-mrp-dual-read-mrp-data',
  'ff-sps-4238-disable-subindex-default',
  'ff-sps-4591-app-search-index-updates',
  'ff-sps-4617-mrp-cluster-migration',
  'ff-sps-4710-lib-install-no-profile-slug',
  'ff-sps-4714-is-agency-or-freelancer-update',
  'ff-sps-4731-partner-points-promo',
  'ff-sps-4821-expanded-partner-program',
  'ff-struct-3445-skip-maintenance-backup-site-version',
  'ff-styl-2313-typography-more-options-redesign',
  'ff-styl-571-import-from-link',
  'ff-user-signups',
  'ff-wfa-1703-analyze-growth-experiment-user-group',
  'ff-wfa-1789-growth-on-publish',
  'ff-wfa-1862-analyze-compete-growth-ipn',
  'ff-wfa-1869-analyze-demo-mode',
  'ff-wfa-1870-nest-goal-data',
  'ff-wfa-1877-nest-page-data',
  'ff-wfa-1934-audience-filtering',
  'ff-wfa-1940-audience-reporting',
  'ff-wfa-2002-nest-scroll-depth-data',
  'ff-wfa-2008-analyze-nest-browser-window-height',
  'ff-wfa-2061-audience-filtering-backfill',
  'ff-work-1170-page-branching-operations',
  'ff-work-1775-branch-automation',
  'ff-work-1828-optimized-ix2-dedup',
  'idsc-802-improved-user-create-flow',
  'mrkpl-2313-app-payments-creator',
  'op-1532-redirect-tests',
  'op-2313-graduation-flows-release-5',
  'optimization-primary-goals-op-1083',
  'sps-3352-partner-commissions-v2',
  'sps-3905-oidc-provider',
  'sps-397-lowercase-siteprofile-slugs',
  'sps-4669-optimize-maybereportrevenueforinvoice',
  'wfa-691-behavioral-analytics',
];
